import { render, staticRenderFns } from "./edit-message-patterns-compact.vue?vue&type=template&id=0c655672&scoped=true&"
import script from "./edit-message-patterns-compact.vue?vue&type=script&lang=js&"
export * from "./edit-message-patterns-compact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c655672",
  null
  
)

export default component.exports